import React from "react";
import { Clock, Truck, BadgeDollarSign, Star } from "lucide-react";
import { whyChooseUs } from "../mock";

const iconMap = { Clock, Truck, BadgeDollarSign, Star };

const WhyChoose = () => {
  return (
    <section className="py-16 lg:py-20 bg-black">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {whyChooseUs.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={i}
                className="group brand-card p-6 rounded-xl hover:border-red-600 transition-colors duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-red-950/60 group-hover:bg-red-600 transition-colors flex items-center justify-center border border-red-700/40">
                  <Icon className="w-6 h-6 text-red-500 group-hover:text-white transition-colors" strokeWidth={2.2} />
                </div>
                <h3 className="mt-4 font-bold text-white text-lg">{item.title}</h3>
                <p className="mt-2 text-zinc-400 text-sm leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
